import { useMediaQuery, useTheme, Button, Box } from '@mui/material';
import ListCell from 'components/list/list-cell';
import ListRow from 'components/list/list-row';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory, useParams } from 'react-router-dom';
import { Site } from '../types/site.type';
import AscSmallCheck from 'components/asc/asc-small-check';
import { Check } from 'lucide-react';
import { SiteTab } from 'views/site-settings/types/site-tab.type';

interface SiteRowParams {
  siteTab: SiteTab;
}

type Props = {
  site: Site;
};

const SiteRow: React.FC<Props> = ({ site }) => {
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { siteTab } = useParams<SiteRowParams>();

  const handleOnClick = (url: string) => {
    history.push(url);
  };

  return (
    <ListRow onClick={() => handleOnClick(`/site-settings/sites/${site.globalSiteId}/inventory-silo-management`)}>
      <ListCell align="left" sx={{ whiteSpace: 'break-spaces !important' }}>
        {site.name}
      </ListCell>
      <ListCell align="center">{site.siteErpId}</ListCell>
      {(siteTab === SiteTab.ACTIVE) && (
        <ListCell align="center">
          {site.hasOfdEnabled && (

            <Check />
          )}
        </ListCell>
      )}

      <ListCell align="center">
        {(site.hasAutomaticOrderingEnabled) && (
          <Check />
        )}
      </ListCell>
      <ListCell align="center">
        {(site.isAscCertified) && (
          <AscSmallCheck dark />
        )}
      </ListCell>


      <ListCell align="right" sx={{ width: { xs: '100%', md: 'auto' } }}>
        <Button
          fullWidth={isMobile}
          size="small"
          onClick={() => handleOnClick(`/site-settings/sites/${site.globalSiteId}/inventory-silo-management`)}>
          <FormattedMessage id="general.view" />
        </Button>
      </ListCell>
    </ListRow>
  );
};

export default SiteRow;
